<template>
  <div>
    <div>
      <b>{{ drag ? "拖拽中" : "拖拽进行排序" }}</b>
      <i
        title="重置"
        @click="resetClick()"
        style="margin-left: 5px; cursor: pointer"
        class="el-icon-refresh"
      ></i>
    </div>
    <div class="dragSort">
      <dragSort
        v-model="titleList"
        chosenClass="chosen"
        forceFallback="true"
        animation="1000"
        @start="onStart"
        @end="onEnd"
      >
        <transition-group>
          <div
            class="item"
            v-for="(element, dragIndex) in titleList"
            :key="dragIndex + 1"
          >
            <div>
              <el-checkbox
                class="checkboxOne"
                @change="isShowClick()"
                v-model="element.isShow"
              ></el-checkbox>
            </div>
            <div>
              <img
                @click="widthClick(element)"
                class="imgOne"
                :src="
                  element.fixedState == true ? '/images/btn_1.png' : '/images/btn_2.png'
                "
              />
            </div>
            <div class="span">{{ element.name }}</div>
            <div style="text-align: right">
              <el-popover placement="right" width="30" trigger="click">
                <div @click="alignItem(element, 'left')" class="align_item">左对齐</div>
                <div @click="alignItem(element, 'center')" class="align_item">
                  居中对齐
                </div>
                <div @click="alignItem(element, 'right')" class="align_item">右对齐</div>
                <img slot="reference" class="imgOne" src="/images/btn_3.png" />
              </el-popover>
            </div>
          </div>
        </transition-group>
      </dragSort>
      <div style="margin-top: 5px">
        <el-checkbox disabled style="margin-left: 6px"></el-checkbox>
        <img class="imgOne" :src="'/images/btn_1.png'" />
        <span style="margin-left: 5px">操作</span>
        <img
          style="float: right; margin-right: 11px"
          class="imgOne"
          src="/images/btn_3.png"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    // table显示的标头集合
    titleList: {
      type: Array,
      required: false,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      drag: false,
      titleList_copy: this.titleList
    };
  },
  methods: {
    // 开始拖拽事件
    onStart() {
      this.drag = true;
      this.$emit('onStart', this.titleList);
    },
    // 对齐方式
    alignItem(element, align) {
      this.drag = false;
      element.align = align;
      this.$emit('onEnd', this.titleList);
      document.body.click();
    },
    // 拖拽结束事件
    onEnd() {
      this.drag = false;
      this.$emit('onEnd', this.titleList);
    },
    // 复选框事件
    isShowClick() {
      this.$emit('isShowClick', this.titleList);
    },
    // 固定方向事件
    widthClick(data) {
      data.fixedState = !data.fixedState;
      this.$emit('widthClick', this.titleList);
    },
    // 重置
    resetClick() {
      this.$emit('resetClick', this.titleList);
    }
  }
};
</script>
<style lang="scss" scoped>
.imgOne {
  width: 14.36px;
  height: 14.36px;
  margin: 0 5px 0 5px;
  vertical-align: top;
}
.item {
  padding: 6px;
  background-color: #fdfdfd;
  cursor: pointer;
  -ms-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  display: flex;
}
.checkboxOne {
  position: relative;
  z-index: 1000;
}
.span {
  width: 400px;
  overflow: hidden; //超出的文本隐藏
  text-overflow: ellipsis; //用省略号显示
  white-space: nowrap; //不换行
}
.dragSort {
  max-height: 220px;
  overflow-y: auto;
}

.align_item {
  cursor: pointer;
  padding: 2px;
}
.align_item:hover {
  background-color: #1476c3;
  color: #ffffff;
}
</style>
